(function () {
  var STORAGE_KEY = "dotthz-per-row";

  function applyPerRow(value) {
    if (!value) return;

    document.querySelectorAll(".per-row__button").forEach(function (btn) {
      var active = btn.getAttribute("data-per-row") === value;
      btn.classList.toggle("active", active);
      btn.setAttribute("aria-pressed", active ? "true" : "false");
    });

    document.querySelectorAll("[data-productis-in-row], #ProductGridContainer, .products-grid").forEach(function (grid) {
      grid.setAttribute("data-productis-in-row", value);
    });

    // Also stamp the list itself so CSS can target either parent or list.
    document.querySelectorAll("#product-grid, .collection-product-list").forEach(function (list) {
      list.setAttribute("data-productis-in-row", value);
      list.classList.remove("collection-product-list--per-row-small", "collection-product-list--per-row-large");
      list.classList.add("collection-product-list--per-row-" + value);
    });

    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
  }

  function bindProductsPerRow() {
    var saved = null;
    try {
      saved = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {}
    if (saved === "small" || saved === "large") {
      applyPerRow(saved);
    }
  }

  // Event delegation survives facet AJAX re-renders.
  document.addEventListener(
    "click",
    function (event) {
      var btn = event.target.closest(".per-row__button");
      if (!btn) return;
      event.preventDefault();
      event.stopPropagation();
      var value = btn.getAttribute("data-per-row");
      if (!value) return;
      applyPerRow(value);
    },
    true
  );

  document.addEventListener("shopify:section:load", bindProductsPerRow);
  document.addEventListener("DOMContentLoaded", bindProductsPerRow);
  if (document.readyState !== "loading") bindProductsPerRow();
})();
